var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"content--user"},[_c('top-bar',{attrs:{"is-admin":false}}),_c('router-view',{key:_vm.key})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }